import { PracticeFormAnswerScaleData } from "@physiofit-digital/physiofit_types";
import { styled } from "styled-components";
import { CustomButton } from "../../../../core/components/buttons/CustomButton";
import { getUserAnswerToQuestion } from "../../../../core/store/currentFormSlice";
import { useMainStore } from "../../../../core/store/mainStore";
import { Body } from "../../../../core/styles/stringStyles";
import { hexWithOpacity } from "../../../../core/utils/helpers";

type Props = {
  questionId: string;
  answerId: string;
  scaleData?: PracticeFormAnswerScaleData;
};

export const ScaleAnswer = ({ questionId, answerId, scaleData }: Props) => {
  const questionAnswer = useMainStore((state) =>
    getUserAnswerToQuestion(state, answerId),
  )?.textValue;
  const setUserAnswerToQuestion = useMainStore(
    (state) => state.setUserAnswerToQuestion,
  );

  const deleteUserAnswerToQuestion = useMainStore(
    (state) => state.deleteUserAnswerToQuestion,
  );

  const handleScaleSelect = (value: number) => {
    const patientAnswer = {
      id: answerId,
      textValue: value.toString(),
    };
    setUserAnswerToQuestion(questionId, patientAnswer, answerId);
  };

  const handleScaleDeselect = () => {
    deleteUserAnswerToQuestion(questionId, answerId);
  };

  const handleButtonClick = (value: number) => {
    if (questionAnswer === value.toString()) {
      handleScaleDeselect();
    } else {
      handleScaleSelect(value);
    }
  };

  const scaleMin = scaleData?.min ?? 0;
  const scaleMax = scaleData?.max ?? 10;

  return (
    <ScaleContainer>
      {Array.from(
        { length: scaleMax - scaleMin + 1 },
        (_, i) => i + scaleMin,
      ).map((value) => (
        <ScaleButton
          key={value}
          onClick={() => handleButtonClick(value)}
          $selected={questionAnswer === value.toString()}
        >
          <ScaleText $selected={questionAnswer === value.toString()}>
            {value}
          </ScaleText>
        </ScaleButton>
      ))}
    </ScaleContainer>
  );
};

const ScaleContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
`;

const ScaleButton = styled(CustomButton)<{ $selected: boolean }>`
  padding: 10px;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background-color: ${(props) =>
    props.$selected
      ? props.theme.colors.primary
      : hexWithOpacity(props.theme.colors.medium, 0.1)};
`;

const ScaleText = styled(Body)<{ $selected: boolean }>`
  text-align: center;
  color: ${(props) =>
    props.$selected
      ? props.theme.colors.background
      : props.theme.colors.medium};
`;
